define('navigation-validation',['helpers', 'training', 'user-answers', 'store'], function(helpers, Training, UserAnswers, Store) {
    'use strict';

    var validation,
        training,
        userAnswers,
        store = Store.default;

    function Validation(options) {
        this.navigation = options.navigation || {};
    }

    Validation.prototype.getPageInactive = function(entity) {
        var error = {
                canContinue: false
            },
            props = helpers.state.getProps(store.getState());

        if (props.isInactive) {
            error.entity = entity;
            error.reason = 'page-is-inactive';
            return error;
        }

        return;
    };

    Validation.prototype.getPageInteraction = function(ID, entity) {
        var error = {
                canContinue: false
            };

        if (!ID || helpers.entity.isQuizPage(entity)) {
            return;
        }

        if (!training.scormPackage && !userAnswers.isPageVisited(ID) || training.scormPackage && document.querySelectorAll('[data-interacted="false"]').length) {
            error.entity = entity;
            error.reason = 'page-missing-interaction';
            return error;
        }

        return;
    };

    Validation.prototype.getMissing = function(entity) {
        var progress,
            ID = (entity) ? entity.contentEntityId : '',
            error = {
                canContinue: false
            };

        if (!ID) {
            return;
        }

        if (training.sequence && helpers.entity.isContentPage(entity) && !userAnswers.isPageVisited(ID)) {
            error.entity = entity;
            error.reason = 'content-page-not-visited';
            return error;
        }

        if (helpers.entity.isTaskPage(entity) && (training.sequence || entity.contentEntity.requiresAnswer) && !userAnswers.isTaskPageAnswered(ID)) {
            error.entity = entity;
            error.reason = 'task-page-not-answered';
            return error;
        }

        if (helpers.entity.isQuizPage(entity)) {
            progress = userAnswers.getQuizPageProgress(ID);

            if (training.sequence && progress && !progress.isAnswered && !progress.isVisited) {
                error.entity = entity;
                error.reason = 'quiz-page-not-answered';
                return error;
            }
            if (entity.contentEntity.requiresCompletion && progress && !progress.isPassed && !progress.isVisited) {
                error.entity = entity;
                error.reason = 'quiz-page-not-passed';
                return error;
            }
        }

        if (helpers.entity.isContentPage(entity) && helpers.entity.isQuizGamePage(entity) && !userAnswers.isQuizGamePagePassed(ID)) {
            error.entity = entity;
            error.reason = 'quiz-game-page-not-passed';
            return error;
        }

        return;
    };

    Validation.prototype.getCurrentQuizTask = function(ID) {
        var error = {
                canContinue: false,
                type: 'current'
            },
            entity = training.getEntity(ID);

        error = this.getPageInteraction(ID, entity) || error;

        if (error.reason) {
            error.type = 'current';
            return error;
        }

        if (!userAnswers.isTaskPageAnswered(ID)) {
            error.entity = entity;
            error.reason = 'task-page-not-answered';
            return error;
        }

        return;
    };

    Validation.prototype.getParentQuizPage = function(ID) {
        var entity = null,
            parentID =  (ID) ? this.navigation.getParentID(ID) : null,
            error = {
                canContinue: false,
                type: 'current'
            },
            progress = null;

        if (!parentID) {
            return;
        }

        entity = training.getEntity(parentID);

        if (entity && helpers.entity.isQuizPage(entity)) {
            progress = userAnswers.getQuizPageProgress(parentID);
        }

        if (!progress) {
            return;
        }

        if (progress.inProgress) {

            if (this.direction === 'forward') {

                error = this.getCurrentQuizTask(this.ID) || error;

                if (error.reason) {
                    return error;
                }
            }

            if (!!entity.contentEntity.canSubmitMultipleTimes && this.targetID === parentID) {
                error.entity = entity;
                error.reason = 'quiz-progress-reset';
                return error;
            }

            if (!progress.isAnswered) {
                error.entity = entity;
                error.reason = 'quiz-page-in-progress';
                return error;
            }

        } else if (progress.isVisited) {

            if (training.entityID !== ID) {
                return;
            }

            error = this.getCurrentQuizTask(this.ID) || error;

            if (error.reason) {
                return error;
            }

            return;
        } else if (!!entity.contentEntity.requiresCompletion && this.targetID !== parentID && this.targetID !== training.modularMenuPageID && !progress.isPassed && !progress.isVisited) {
            error.entity = entity;
            error.reason = 'quiz-page-not-passed';
            return error;
        }

        return;
    };

    Validation.prototype.getCurrentMissing = function(ID) {
        var entity,
            error;

        ID = ID || '';

        if (ID) {
            entity = training.getEntity(ID);
        }

        if (!entity) {
            return;
        }

        error = this.getPageInactive(entity);

        if (error) {
            error.type = 'current';
            return error;
        }

        error = this.getPageInteraction(ID, entity);

        if (error) {
            error.type = 'current';
            return error;
        }

        error = this.getMissing(entity);

        if (error) {
            error.type = 'current';
            return error;
        }

        return error;
    };

    Validation.prototype.getPreviousMissing = function(index, current) {
        var i = 0,
            ID,
            error,
            entity;

        while (i < index) {
            ID = training.trainingMap[i];
            entity = training.getEntity(ID);

            if (entity) {
                error = this.getMissing(entity);

                if (error) {
                    error.type = (i > current) ? 'subsequent' : 'previous';
                    break;
                }
            }

            i++;
        }

        return error;
    };

    Validation.prototype.setAdditional = function(error, index, map) {
        error = error || {};
        error.missing = {};
        error.target = {};

        var ID = map[index] || null,
            entity;

        if (error.entity && error.entity.contentEntity && (error.entity.contentEntity.name || error.entity.contentEntity.title)) {
            error.missing = {
                ID: error.entity.contentEntityId,
                title: error.entity.contentEntity.name || error.entity.contentEntity.title
            };
        }

        if (ID) {
            entity = training.getEntity(ID);
        }

        if (entity && entity.contentEntity && (entity.contentEntity.name || entity.contentEntity.title)) {
            error.target.title = entity.contentEntity.name || entity.contentEntity.title;
        }

        return error;
    };

    Validation.prototype.validate = function(options) {
        options = options || {};

        this.ID = options.ID || '';
        this.targetID = options.targetID ||  '';
        this.direction = (options.direction) ? options.direction.toLowerCase() : null;

        var index = -1,
            targetIndex = -1,
            parentID,
            parentIndex = -1,
            error,
            success = {
                canContinue: true
            };

        if (helpers.entity.isQuizTaskPage(this.ID, training.contentEntities) && helpers.entity.isQuizTaskPage(this.targetID, training.contentEntities)) {

            index = this.navigation.getIndex(this.ID, this.navigation.getQuizMap(this.ID));
            targetIndex = this.navigation.getIndex(this.targetID, this.navigation.getQuizMap(this.ID));

            if (index >= targetIndex) {
                return success;
            }

            error = this.getCurrentQuizTask(this.ID);

            if (error) {
                error = this.setAdditional(error, targetIndex, this.navigation.getQuizMap(this.ID));
                return error;
            }

        } else if (helpers.entity.isQuizTaskPage(this.ID, training.contentEntities)) {

            error = this.getParentQuizPage(this.ID);

            if (error) {
                error = this.setAdditional(error, targetIndex, training.trainingMap);
                return error;
            }

            parentIndex = this.navigation.getIndex(this.navigation.getParentID(this.ID), training.trainingMap);
            targetIndex = this.navigation.getIndex(this.targetID, training.trainingMap);

            if (targetIndex > parentIndex) {

                error = this.getCurrentMissing(parentID);

                if (error) {
                    error = this.setAdditional(error, targetIndex, training.trainingMap);
                    return error;
                }

                error = this.getPreviousMissing(targetIndex, parentIndex);

                if (error) {
                    error = this.setAdditional(error, targetIndex, training.trainingMap);
                    return error;
                }
            }

        } else {

            index = this.navigation.getIndex(this.ID, training.trainingMap);
            targetIndex = this.navigation.getIndex(this.targetID, training.trainingMap);

            if (index >= targetIndex) {
                return success;
            }

            error = this.getCurrentMissing(this.ID);

            if (error) {
                error = this.setAdditional(error, targetIndex, training.trainingMap);
                return error;
            }

            error = this.getPreviousMissing(targetIndex, index);

            if (error) {
                error = this.setAdditional(error, targetIndex, training.trainingMap);
                return error;
            }

        }

        return success;
    };

    return function(options) {

        if (!validation) {
            training = new Training();
            userAnswers = new UserAnswers();
            validation = new Validation(options);
        }

        return validation;
    };

});

